var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"inner-details"},_vm._l((_vm.modifiers),function(modifier,key){return _c('li',{key:key},[_vm._v("\n    "+_vm._s(_vm._T_DB(modifier, 'name'))+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }